export function NoAdsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.45 35.9191C7.36826 35.9191 5.67 34.2209 5.67 32.1391V10.2444C5.67 8.16262 7.36826 6.46436 9.45 6.46436H23.3009C29.82 6.46436 35.1248 11.7691 35.1248 18.2883V32.1391C35.1248 34.2209 33.4265 35.9191 31.3448 35.9191H9.45Z"
        fill="url(#paint0_linear_21268_24283)"
      />
      <path
        d="M34.9148 16.6084C35.1796 20.2971 33.5361 23.6114 30.87 25.6749V30.5049C30.87 31.144 30.3587 31.6645 29.7104 31.6645H11.0844C10.4452 31.6645 9.92479 31.1532 9.92479 30.5049V11.8697C9.92479 11.2306 10.4361 10.7101 11.0844 10.7101H16.4074C18.5074 8.15359 21.8126 6.61968 25.4648 6.95751C30.4957 7.41403 34.5678 11.5684 34.9148 16.6084Z"
        fill="url(#paint1_linear_21268_24283)"
      />
      <path
        d="M25.1543 26.0401C30.2272 26.0401 34.3396 21.9278 34.3396 16.8549C34.3396 11.782 30.2272 7.66968 25.1543 7.66968C20.0815 7.66968 15.9691 11.782 15.9691 16.8549C15.9691 21.9278 20.0815 26.0401 25.1543 26.0401Z"
        fill="white"
      />
      <path
        d="M25.1543 4.37354C18.27 4.37354 12.6639 9.97962 12.6639 16.864C12.6639 23.7483 18.27 29.3544 25.1543 29.3544C32.0387 29.3544 37.6448 23.7483 37.6448 16.864C37.6448 9.97962 32.0387 4.37354 25.1543 4.37354ZM25.1543 8.6831C26.6335 8.6831 28.003 9.07571 29.2083 9.76049L18.06 20.9088C17.3752 19.7127 16.9826 18.334 16.9826 16.8548C16.9826 12.3535 20.653 8.6831 25.1543 8.6831ZM25.1543 25.0357C23.6752 25.0357 22.3056 24.6431 21.1004 23.9583L32.2487 12.8101C32.9335 14.0061 33.3261 15.3848 33.3261 16.864C33.3261 21.3653 29.6556 25.0357 25.1543 25.0357Z"
        fill="url(#paint2_linear_21268_24283)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21268_24283"
          x1="12.5178"
          y1="37.59"
          x2="26.6609"
          y2="8.15349"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.52" stopColor="#00FC00" stopOpacity="0.89" />
          <stop offset="0.68" stopColor="#17FC00" stopOpacity="0.92" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21268_24283"
          x1="23.9035"
          y1="7.10359"
          x2="19.3474"
          y2="31.8471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.16" stopColor="#F0FFE3" />
          <stop offset="0.41" stopColor="#DBFFBC" />
          <stop offset="0.64" stopColor="#CCFFA0" />
          <stop offset="0.85" stopColor="#C3FF90" />
          <stop offset="1" stopColor="#C0FF8A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_21268_24283"
          x1="12.4083"
          y1="38.9322"
          x2="28.9252"
          y2="10.3266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007900" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
      </defs>
    </svg>
  )
}
